// extracted by mini-css-extract-plugin
export var about__content = "about-module--about__content--U+HOM";
export var row = "about-module--row--+q0Zq";
export var aboutText = "about-module--about-text--1AWnJ";
export var photoCredit = "about-module--photo-credit--SBjhB";
export var reverse = "about-module--reverse--kk79m";
export var aboutImg = "about-module--about-img--4Q03o";